module.exports = __webpack_public_path__ + "static/media/vizulinkLogo.1586edaa.svg";